import React from 'react'
import { t } from '../../i18n/i18n'
import { GridItem } from '../common/grid/GridItem'
import { ControlledOrgDetailsDropDown } from '../common/inputs/ControlledOrgDetailsDropDown'
import { SniDropdown } from '../common/inputs/SniDropdown'
import { ControlledTextInput } from '../common/inputs/TextInput'
import { UseFormReturn } from 'react-hook-form'
import { Organisation, SNI } from '../../api/schemas/schema'
import { IDropdownOption } from '../../interfaces/IDropdownOptions'
import { ControlledOrganisationNumberInput } from '../common/inputs/ControlledOrganisationNumberInput'
import { InfoMessageBar } from '../common/other/InfoMessageBar'

type OrganisationDetailsFormProps = {
   organisationForm: UseFormReturn<Organisation, any, Organisation>
   orgSizes: IDropdownOption[]
   orgTypes: IDropdownOption[]
   snis: SNI[]
   isSandbox: boolean
   disabledOrgNumber?: boolean
}

export const OrganisationDetailsForm = ({ organisationForm, orgSizes, orgTypes, snis, isSandbox }: OrganisationDetailsFormProps) => {
   const { control, setValue } = organisationForm

   return (
      <>
         <GridItem size={'12/12'}>
            <InfoMessageBar title={t('ContactSalesRepresentativeToChangeOrgDetails')} />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrganisationNumberInput required control={control} name={'organisationNumber'} label={t('OrganisationNumber')} disabled />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledTextInput required control={control} name={'name'} label={t('CompanyName')} disabled />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrgDetailsDropDown
               required
               control={control}
               name={'organisationSize'}
               label={t('OrganisationSize')}
               options={orgSizes}
               setValue={setValue}
               disabled={!isSandbox}
            />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrgDetailsDropDown
               required
               control={control}
               name={'organisationType'}
               label={t('OrganisationType')}
               options={orgTypes}
               setValue={setValue}
               disabled={!isSandbox}
            />
         </GridItem>
         <GridItem size={'12/12'}>
            <SniDropdown required organisationForm={organisationForm} label={t('SNI')} items={snis ? snis : []} disabled={!isSandbox} />
         </GridItem>
      </>
   )
}
